import { constructEnum } from '@/lib/enum';

export default constructEnum('ReviewOptionFieldType', {
  TEXT: 0,
  NUMBER: 10,
  SELECT: 20
});
